<template>
  <div>
    <v-container v-if="!bCargando" fluid>
      <v-row dense class="no-gutters cont-superior justify-space-between pa-2">
        <v-col cols="6">
          <v-btn dark small outlined @click="volver()" class="btn-active-primary" v-if="getIdPrevPage !== ''">
            <v-icon left>fas fa-reply</v-icon>
            <span class="text-max"><b>Volver</b></span>
          </v-btn>
        </v-col>
        
        <v-col cols="6" class=" text-right">
          <v-btn dark small outlined @click="printSection()" class="btn-active-primary"> 
            <span class="text-max"><b>Exportar</b></span> 
            <v-icon right>mdi-file-export</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else fluid>
      <v-row  justify="center" align="center" class="imprimir ma-10" dense>
        <v-col sm="12" md="12" lg="12" xl="12" justify="center" align="center">
            <BreedingRhombusSpinner
              class="mx-auto"
							:animation-duration="2000"
							:size="50"
							color='#0E69B0'
						/>
        </v-col>
        <v-col sm="12" md="12" lg="12" xl="12" justify="center" align="center" class="mt-10">
          <h2 class="text-primary">Cargando información ...</h2>
        </v-col>  
      </v-row>  
    </v-container>
    <div id="printPage" class="pa-3 print-principal" :class="{'print-max-ancho': bShowExport}" v-if="aHeader.Titulo!=''&&aHeader.Titulo!=null">
      <v-container v-if="!bCargando" fluid>
        <div class="imprimir">
          <v-row dense class="no-gutters">
            <v-col cols="12" class="pa-3">
              <h2 id="titleForm" class="text-center text-semibold text-primary font-size-2">
                FORMULARIO No. {{ onIdFormulario }} - {{ aHeader.Titulo }}
              </h2>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row justify="center" align="center" dense class="no-gutters">
            <v-col  cols="12" sm="4" class="pa-2">
              <div id="sImgReference" style="border: 1px; text-align: center;">
                <v-img id="Logo" style="width: 200px;" :src="LogoImageURL" contain>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center">
                      <v-progress-circular
                        indeterminate
                        color="blue lighten-3">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pa-2">
                <span class="text-semibold h4 text-uppercase">Usuario Gestor</span>
                <p class="text-capitalize ma-0">{{ aHeader.Usuario }}</p>
            </v-col>
            <v-col cols="12" sm="4" class="pa-2">
                <span class="text-semibold h4 text-uppercase">Fecha Elaboración</span>
                <p class="text-capitalize  ma-0">{{ aHeader.Fecha }}</p>
            </v-col>
          </v-row>
        <v-divider></v-divider>
        </div>
        <v-row justify="center" align="center" dense>
          <v-col sm="12" md="12" lg="12" xl="12">
            <div v-for="(oData, indice) in aData" :key="indice">
              <v-card class="imprimir" elevation="0">
                <component :is="oData.TipoCampo"
                  :aItems="oData">
                </component>
              </v-card>
              <div v-if="oData.TipoCampo == 'SubFormulario'">
                <div v-for="(oSubData, index) in oData.Respuesta" :key="index">
                  <v-card class="imprimir" elevation="0" tile>
                    <component :is="oSubData.TipoCampo"
                      :aItems="oSubData">
                    </component>
                  </v-card>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row  v-if="!bCargando && aHeader.Latitud!=='0' && aHeader.Latitud!=='0.0'" justify="center" align="center" class="imprimir" dense>
            <Bloque
              title="UBICACIÓN">
            </Bloque>
            <MapaView v-if="!bCargando"
              :key="nkeyRefresMap"
              :lat="aHeader.Latitud"
              :lng="aHeader.Longitud"
              :isDraggable="false">
            </MapaView>
        </v-row>
      </v-container>
    </div>
    <div v-else-if="!bCargando">
      <v-col cols="12"  class="text-center pa-1 under-sec-flat-gray">
        <v-icon color="primary" class="animated bounceIn dura-1" size="60px">mdi-information</v-icon>
        <h2 class="text-medium text-primary font-size-1">
          Sin información para mostrar
        </h2>
      </v-col>
    </div>
    <v-dialog v-model="bShowExport" persistent width="450">
      <v-card
        color="primary"
        class="text-center"
        dark>
        <v-card-title class="text-h5 mb-2">
          Exportando reporte
        </v-card-title>
        <FulfillingSquareSpinner
              class="mx-auto"
							:animation-duration="4000"
							:size="50"
							color='#FFFFFF'
						/>
        <v-card-text class="text-info mt-4">
          La generación del reporte puede tardar unos minutos, dependiendo de la conexión a internet o características del equipo.
        </v-card-text>
        <v-card-text style="text-align: center;">
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!-- <div v-else class="text-center pa-2">
    <v-icon color="primary" class="animated bounceIn dura-1" size="100px">mdi-information</v-icon>
    <h2 class="text-medium text-primary">
      No hay informacion disponible
    </h2>
  </div> -->
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'
import Bloque from '@/components/FormDinamicos/Componentes/Bloque.vue'
import SubFormulario from '@/components/FormDinamicos/Componentes/SubFormulario.vue'
import RespuestaSencilla from '@/components/FormDinamicos/Componentes/RespuestaSencilla.vue'
import Grupo from '@/components/FormDinamicos/Componentes/Grupo.vue'
import Foto from '@/components/FormDinamicos/Componentes/Foto.vue'
import Firma from '@/components/FormDinamicos/Componentes/Firma.vue'
import MultiSelect from '@/components/FormDinamicos/Componentes/Multiselect.vue'
import Correo from '@/components/FormDinamicos/Componentes/Correo.vue'
import { mapGetters } from 'vuex'
import MapaView from '@/components/Mapas/mapLocalizar.vue'
import { FulfillingSquareSpinner } from 'epic-spinners'
import { BreedingRhombusSpinner } from 'epic-spinners'

export default {
  name: 'FormDinamicoReporte',
  components: {
    Bloque,
    SubFormulario,
    RespuestaSencilla,
    Grupo,
    Foto,
    Firma,
    MultiSelect,
    Correo,
    MapaView,
    FulfillingSquareSpinner,
    BreedingRhombusSpinner
  },
  data () {
    return {
      bCargando : true,
      LogoImageURL : '',
      aHeader : [],
      aData : [],
      bShowExport : false,
      nkeyRefresMap : 0,
      bNoInfo: false
    }
  },
  props: {
    sIDFormulario: { // Id del formulario dinamico
      default:''
    },
    sTabla: { // Tabla de configuracion
      type:String,
      default:''
    },
    sIdCliente: { // Tabla de configuracion
      type:String,
      default:''
    },
  },
  async mounted () {
    this.bCargando = true
    await this.getHeader()   // siempre de primero
    await this.getOrderData()
    this.nkeyRefresMap++
    this.bCargando = false
    this.getLogo()
  },
  methods: {
    getLogo () {
      let sParams = `sPath=LogoImagen${(this.sIdCliente === '') ? '' : `&nCliente=` + this.sIdCliente }`
      axiosServices.getConfiguration('FormDinamicoReporte_Path', false, sParams).then(getPath => {
        this.LogoImageURL = getPath.aData
      })
    },
    async getHeader () {
      const getHeader = await axiosServices.getConfiguration(`FormDinamicoReporte_Header/${this.onIdFormulario}`, false, `sModoTabla=${this.sTabla}`)
      if (typeof getHeader.aData === 'boolean'){
        this.bNoInfo = true
      }else{
        this.aHeader = await getHeader.aData
      }
      

      this.nkeyRefresMap++
    },
    async getOrderData () {
      const getBody = await axiosServices.getConfiguration(`FormDinamicoReporte_Body/${this.onIdFormulario}`, false, `sModoTabla=${this.sTabla}`)

      this.aData = await getBody.aData

    },
    async printSection() {
      // Se imprime todo lo que este detro del div id printPage y los componentes principales que tengan la class imprimir
      this.bShowExport = true
      let elements = document.querySelectorAll("#printPage .imprimir")
      let doc = new jsPDF('p', 'mm', 'letter', true)
      doc.setFillColor(245);
      doc.rect(0, 0, 210, 700, "F");
      doc.margins = {
        top: 40,
        bottom: 60,
        left: 60,
        right: 60
      };
      const imgWidth = doc.internal.pageSize.getWidth()
      // console.log(imgWidth)
      const pageHeight = doc.internal.pageSize.getHeight() - 5
      // console.log(pageHeight)
      let position = 5
      let pageHeightLeft = pageHeight
      for (let i = 0; i < elements.length; i++) {
        await html2canvas(elements[i], {
          scale: 2,
          useCORS: true,
          allowTaint: true,
        }).then(function(canvas) {
          let imgData = canvas.toDataURL('image/png', 1.0)
          let imgHeight = canvas.height * imgWidth / canvas.width
          // Comprobamos salto
          if (pageHeightLeft - imgHeight <= 0) {
            doc.addPage()
            pageHeightLeft = pageHeight
            position = 5 // Pintaremos en el inicio de la nueva pagina
          }
					// window.open(imgData);
          doc.addImage(imgData, 'PNG', 5, position, (imgWidth - 10), imgHeight, '', 'FAST')
          position += imgHeight // Marcamos el siguiente inicio
          pageHeightLeft -= imgHeight // Marcamos cuanto espacio nos queda
        })
      }
      doc.save(`${document.getElementById('titleForm').textContent.trim()}.pdf`)
      this.bShowExport = false
    },
    resize () {
      if (window.addEventListener) {  // all browsers except IE before version 9
        window.addEventListener("resize", onResizeEvent, true);
      }
      function onResizeEvent() {
        let divImgElement = document.getElementById("sImgReference")
        let newWidth = divImgElement.clientWidth
        let oImgRender = document.getElementById("Logo")
        oImgRender.style.width = `${newWidth}px`
      }
    },
    volver() {
      this.$router.replace({path : `/GridDinamicos/${this.getIdPrevPage}`})
    }
  },
  computed: {
    ...mapGetters(['getIdPrevPage']),
    onIdFormulario() {
      return (this.$route.params.hasOwnProperty('id')) ? this.$route.params.id : this.sIDFormulario 
    }
  },
}
</script>

<style lang="scss" scoped>
.cont-superior{
  background: var(--v-primarydark-base);
  border-radius: 0px 0px 10px 10px;
}
.text-info{
  font-size: 1.1em;
}
.btn-active-primary{
  transition: all 0.2s ease-in-out;
  &:hover{
    background: var(--v-primary-base)!important;
  }
}
.print-principal{
  max-width: 1000px;
    margin: 0 auto;
}
.print-max-ancho{
  width: 1000px;
  margin: 0 auto;
}
</style>